import { useQuery, useQueryClient } from "react-query";
import { mediaSettingsApi } from "@circle-react/api";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { useMediaTranscoding } from "@circle-react/hooks/useMediaTranscoding";
import type { MediaSetting } from "@circle-react/types/MediaSetting";

interface UseMediaSettingsOptions {
  signedId: string;
}

export const useMediaSettings = ({ signedId }: UseMediaSettingsOptions) => {
  const queryClient = useQueryClient();
  const queryKey = ["mediaSettings", signedId] as const;

  const query = useQuery<MediaSetting, ApiError>({
    queryKey,
    queryFn: () => mediaSettingsApi.show(signedId),
  });

  // Support live updates to chapter thumbnails when preview thumbnails are
  // generated after loading media settings
  useMediaTranscoding({
    enabled: !!query.data && !query.data.preview_thumbnails_url,
    signedId,
    onSuccess: ({ previewThumbnailsUrl }) => {
      if (!previewThumbnailsUrl) return;

      queryClient.setQueryData<MediaSetting | undefined>(queryKey, oldData => {
        if (!oldData) return oldData;

        return { ...oldData, preview_thumbnails_url: previewThumbnailsUrl };
      });
    },
  });

  return query;
};
